import api from "../../axiosConfig";

export const addBill = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/bills/create', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getBills = async (searchKeyword, doctor_id, patient_id, limit) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/bills/all', {
      params: {
        search_keyword: searchKeyword,
        doctor_id:doctor_id,
        patient_id:patient_id,
        limit:limit
      },
    });

    const resData = response?.data;
    // console.log('Response data:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching bills');
  }
};

export const updateBill = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/bills/update/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update bill response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating bill');
  }
};

export const deleteBill = async (id) => {
  try {
    const response = await api.delete(`bills/delete/${id}`);

    const resData = response?.data;
    console.log('Delete bill response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting bill');
  }
};